import { render, staticRenderFns } from "./TextHighlighter.vue?vue&type=template&id=58dc9cf8&"
import script from "./TextHighlighter.vue?vue&type=script&lang=ts&"
export * from "./TextHighlighter.vue?vue&type=script&lang=ts&"
import style0 from "./TextHighlighter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58dc9cf8')) {
      api.createRecord('58dc9cf8', component.options)
    } else {
      api.reload('58dc9cf8', component.options)
    }
    module.hot.accept("./TextHighlighter.vue?vue&type=template&id=58dc9cf8&", function () {
      api.rerender('58dc9cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/search/components/TextHighlighter.vue"
export default component.exports